<template>
    <flex-element
        :element-type="elementType"
        :class="htmlClass"
        tag="button"
        :type="type"
        :style="buttonStyle"
    >
        <span :style="textStyle">
            {{ singleLineText }}
        </span>

        <loading-icon
            v-if="isLoading"
            class="fc-center-middle"
            color="#fff"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import listenOnRootMixin from '@/mixins/listen-on-root';
import LoadingIcon from '@/components/shared/loading/loading-icon';

export default {
    name: 'a-button',
    components: { LoadingIcon },
    mixins: [baseAtom, listenOnRootMixin],

    props: {
        singleLineText: {
            type: String,
            default: '',
        },

        type: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        buttonStyle() {
            return {
                pointerEvents: this.isLoading ? 'none' : 'auto',
                '-webkit-appearance': 'none',
            };
        },

        textStyle() {
            return {
                visibility: this.isLoading ? 'hidden' : 'visible',
            };
        },
    },

    created() {
        this.listenOnRoot('flex::form::submit', () => this.isLoading = true);
        this.listenOnRoot('flex::form::response', () => this.isLoading = false);
    },
};
</script>
